export default {
  methods: {
    // TODO: I'd like to conditionally attach the counter of the limit is exceeded, but this interface is cumbersome,
    // so I'm just using a rule to report the count as part of the error message via the 'buildRules' method instead
    // getValidationAttrs({ get, required, limit, pattern }) {
    //   const bind = {};
    //   bind.counter = (limit && ((get(this) || '').length > limit)) ? limit : false;
    //   bind.rules = [
    //     v => {
    //       if (required && !v)
    //         return 'Required';
    //       if (limit && ((v || '').length > limit))
    //         return 'Too long';
    //       if (pattern && !pattern.test(v || ''))
    //         return 'Invalid';
    //       return true;
    //     }
    //   ];
    //   return bind;
    // },

    buildRules({ required, limit, pattern }) {
      return [
        v => {
          if (required && !/\S/.test(v || ''))
            // Note that this also checks for values that contain only whitespace
            return 'Required';
          if (limit && ((v || '').length > limit))
            return `Too long (${(v || '').length} / ${limit})`;
          if (pattern && !pattern.test(v || ''))
            return 'Invalid';
          return true;
        }
      ];
    }
  }
};
